/* eslint-disable no-extra-boolean-cast */
import React, { useEffect, useState } from 'react';
import { SelectGroup } from 'module-tsl-ui-elements';
import { getFromContext } from '../../../AlertFiltersContext';

export const FilterAgeRange = () => {
  const { state, dispatch } = getFromContext();
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(19);

  const [isFacetSelected] = state.facets.filter(({ queryStringId }) => queryStringId.indexOf('ageRange') !== -1);

  const setAges = (minimum = 0, maximum = 19) => {
    const ages = [];
    let count = minimum;

    while (count <= maximum) {
      ages.push({ value: count, label: `${count} years` });
      count += 1;
    }
    return ages;
  };

  const [minRange, setMinRange] = useState(setAges(min, max));
  const [maxRange, setMaxRange] = useState(setAges(min, max));

  useEffect(() => {
    if (isFacetSelected) {
      const numbers = isFacetSelected.queryStringId.split('=')[1];
      const [minimum, maximum] = numbers.split(',');

      setMin(Number(minimum));
      setMax(Number(maximum));
    }
  }, []);

  const handleFacet = (minimum = min, maximum = max) => {
    const facet = {
      name: `From ${minimum} to ${maximum} years old`,
      queryStringId: `ageRange=${minimum},${maximum}`,
      queryAs: `${minimum},${maximum}`,
    };

    dispatch({
      type: isFacetSelected ? 'update' : 'add',
      facet,
      key: 'ageRange',
    });
  };

  const changeMin = ({ target: { value } }) => {
    const age = Number(value);
    setMaxRange(setAges(age));
    setMin(age);
    handleFacet(age, max);
  };

  const changeMax = ({ target: { value } }) => {
    const age = Number(value);
    setMinRange(setAges(0, age));
    setMax(age);
    handleFacet(min, age);
  };

  return (
    <div className="filters__category__age-range">
      <SelectGroup
        self={{}}
        select={{
          options: minRange,
          placeholder: 'Minimum age',
          value: isFacetSelected ? `${min}` : '',
          onChange: changeMin,
        }}
        label={{
          text: 'Minimum Age',
        }}
      />
      <SelectGroup
        self={{}}
        select={{
          options: maxRange,
          value: isFacetSelected ? `${max}` : '',
          placeholder: 'Maximum age',
          onChange: changeMax,
        }}
        label={{
          text: 'Maximum Age',
        }}
      />
    </div>
  );
};
